import request from '../request'
import { BASE_API } from '../Constant'
// @todo this file name should be product service
const baseUrl = `${BASE_API}products`
// const baseApi = `${BASE_API}`
function all() {
  return request({
    url: `${baseUrl}/index`,
    method: 'GET',
  })
}
function getProductById(id) {
  return request({
    url: `${baseUrl}/show/${id}`,
    method: 'GET',
  })
}


const ProductServices = {
  all,
  getProductById
}

export default ProductServices
